import { gql } from "@apollo/client";

export const LIST_VAT_QUERY = gql`
  query listVatsPaginated($filter: VatFilter) {
    listVatsPaginated(filter: $filter) {
      results(limit: 0) {
        id
        rate
        code
      }
    }
  }
`;

export const LIST_VATS_QUERY = gql`
  query listVatsPaginated($limit: Int, $offset: Int, $orderBy: [String], $filter: VatFilter) {
    listVatsPaginated(filter: $filter) {
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        rate
        counterPartSell {
          name
          code
        }
        cycle {
          id
          endDate
          startDate
        }
        showInFact
      }
      totalCount
    }
  }
`;

export const LIST_VATS_QUERY_RATES = gql`
  query listVatsPaginated($limit: Int, $offset: Int, $orderBy: [String], $filter: VatFilterInput) {
    listVatsPaginated(filter: $filter) {
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        rate
        showInFact
      }
      totalCount
    }
  }
`;

export const GET_EXPORTS = gql`
  query listCompanyExports($filter: ListCompanyExportFilter) {
    listCompanyExports(filter: $filter) {
      id
      fileName
      createdAt
      createdBy
      created
      canBeReexported
      autoExported
      reexportedAt
      size
      totalDocuments
      uploadedToInterops
      url
      bookEntriesSource
      minEntryDate
      maxEntryDate
    }
  }
`;

export const EXPORT = gql`
  mutation ExportPlatform($company: ID!, $bookEntriesSource: String, $exportId: ID) {
    exportPlatform(
      input: {
        companyId: $company
        bookEntriesSource: $bookEntriesSource
        exportId: $exportId
      }
    ) {
      downloadUrl
      bookEntriesSource
      success
      successMessage
      errors {
        field
        messages
      }
      successErrorList {
        status
        error
        errorCode
      }
    }
  }
`;
